import { useTranslation } from "@/language/translation";

export function useSharedEABTranslations() {
  const { t } = useTranslation();
  function buttonLabel(key: string): string {
    switch (key) {
      case "components.TaskModal.idea.noVeto":
        return t("components.TaskModal.idea.noVeto");
      case "components.TaskModal.idea.veto":
        return t("components.TaskModal.idea.veto");
      case "components.TaskModal.idea.recommend":
        return t("components.TaskModal.idea.recommend");
      case "components.TaskModal.idea.recommendNotPossible":
        return t("components.TaskModal.idea.recommendNotPossible");
      case "components.TaskModal.idea.recommendNot":
        return t("components.TaskModal.idea.recommendNot");
      case "components.TaskModal.idea.nothing":
        return t("components.TaskModal.idea.nothing");
      default:
        return key;
    }
  }
  return { t, buttonLabel };
}
